import * as Yup from "yup";

export const PackageSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  gender: Yup.string().required("Gender is required"),
  communityValueId: Yup.number().required("Community value is required"),
});
